import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';
import { BasketService } from 'src/app/b2c/basket/services/basket.service';
import { WisthlistService } from 'src/app/b2c/wishlist/services/wishlist.service';
import { MenuAction } from 'src/app/shared/models/menu/menu.records';
import { ProductLicenseService } from 'src/app/b2c/products/services/product.license.service';

@Component({
  selector: 'app-store-item',
  templateUrl: './store-item.component.html',
  styleUrls: ['./store-item.component.scss'],
})
export class StoreItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input() heightType = 'default';
  @Input() mode = 'item';
  @Input() scope = 'app/product';
  @Input() item: any | null = null;
  @Input() hasActions: boolean = true;
  public skeletonImage = true;

  public previewImage: any = null;
  protected licenseSub: Subscription | null = null;

  private isEntered = false;
  private imageCount = 0;
  private currentImage = -1;

  constructor(
    private wishlistService: WisthlistService,
    private basketService: BasketService,
    private translate: TranslocoService,
    private currency: CurrencyPipe,
    private licenseService: ProductLicenseService
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    this.currentId = -1;
  }

  public currentId: number = -1;
  public currentActions: MenuAction[] = [];

  public get actions(): MenuAction[] {
    if (!this.hasActions) {
      return [];
    }
    if (this.item && this.item.id && parseInt(this.item.id) != this.currentId) {
      let gameActions: MenuAction[] = [];

      const hasLicense = this.licenseService.getEdition(parseInt(this.item.id));

      if (!hasLicense && this.item.is_buyable) {
        if (this.item.price.gross.price == 0.0) {
          gameActions.push({
            name: this.translate.translate('product.details.add_to_library'),
            icon: 'library-outline',
            callback: () => {
              this.licenseService.addToLibrary(this.item.id);
            },
          });
        } else if (!this.item.is_pre_release) {
          const price = this.currency.transform(
            this.item.price.gross.price,
            this.item.price.gross.currency,
            'symbol'
          );
          gameActions.push({
            name: this.translate.translate('product.details.buy', { price: price }),
            icon: 'bag-handle-outline',
            callback: () => {
              this.basketService?.create('edition', this.item.id);
            },
          });
        } else if (this.item.is_pre_release) {
          const price = this.currency.transform(
            this.item.price.gross.price,
            this.item.price.gross.currency,
            'symbol'
          );
          gameActions.push({
            name: this.translate.translate('product.details.preorder', { price: price }),
            icon: 'bag-handle-outline',
            callback: () => {
              this.basketService?.create('edition', this.item.id);
            },
          });
        }
      } else if (hasLicense && this.item.is_downloadable) {
        gameActions.push({
          name: this.translate.translate('product.details.play_for_free'),
          icon: 'play-circle-outline',
  
          callback: () => {
            this.licenseService.doDownload(this.item.id);
          },
        });
      }

      this.currentId = parseInt(this.item.id);
      this.currentActions = gameActions;
      return this.currentActions;
    } else if (this.currentId > -1) {
      return this.currentActions;
    } else {
      return [];
    }
  }

  ngOnDestroy(): void {
    this.licenseSub?.unsubscribe();
  }

  get isOnList() {
    if (this.item == null || this.item == undefined) {
      return;
    }

    return this.wishlistService?.isOnWishlist('edition', this.item.id);
  }

  addToWishList(event: any) {
    event.stopPropagation();
    event.preventDefault();
    if (this.item == null || this.item == undefined) {
      return;
    }
    if (this.isOnList) {
      this.wishlistService?.delete('edition', this.item.id);
    } else {
      this.wishlistService?.create('edition', this.item.id);
    }
  }

  imageLoaded($event: any) {
    $event.target.classList.add('loaded');
  }

  ngOnInit() {
    if (this.mode == null || this.mode === undefined) {
      this.mode = 'item';
    }

    if (this.item != null && this.item.preview != null) {
      this.previewImage = this.item.preview.url;
    }

    this.licenseSub = this.licenseService.records.values.subscribe(df => {
      this.currentId = -1;
    });
  }

  public onImageLoad = false;
  finishLoading() {
    this.onImageLoad = true;
  }

  public enableNext = false;

  disableSkeletonImage() {
    this.skeletonImage = false;
  }
}
